import { liquidKind } from '@/play/liquid/kind'
import { gravityEvent } from '@/play/physics/gravityChanges'

/** Every sand voxel of the page is loose sand (the behaviour table's one flow). */
export const APPLE_TREE_SAND = liquidKind('sand', { defaultColor: 0xe2c48a })

/**
 * One frame of gravity (the button held): the bodies that fell and the sand that slid. A whole hold
 * (and the landing after it) is one undo step.
 */
export const APPLE_TREE_GRAVITY = gravityEvent('experience.apple-tree.gravity', APPLE_TREE_SAND)

/** Reducer handlers for Apple tree (`experience.apple-tree.*`). */
export const eventHandlers = APPLE_TREE_GRAVITY.handlers
